import React from "react";

import useTranslation, { getTranslations } from "components/use-hooks/use-translation";


const makeTranslation = (children, params, translations) => {
    let translation = translations[children] ? translations[children] : children;

    if(Object.keys(params).length){

        for( let [ key, value ] of Object.entries( params )){

            const regExp = new RegExp(`{ ${ key } }`, "g");

            if( typeof value === "object" ){

                translation = translation.split(`{ ${key} }`).map( ( item, idx, arr ) => {
                    if(arr.length - 1 > idx){
                        return [item, { ...value, key: `${ key }_${ idx }` }];
                    }

                    return item;
                });

            } else {

                translation = translation.replace(regExp, value);
            }
        }
    }

    return translation;
};

const Localize = ( { children, wrap = false, wrapClass = "", ...params } ) => {

    const translations = useTranslation();
    const translation = makeTranslation(children, params, translations);

    if(wrap){
        let CustomTag = wrap === true ? `span` : `${ wrap }`;

        return <CustomTag className={ wrapClass }>{ translation }</CustomTag>;
    }

    return <>{ translation }</>;
};

export const localizeIt = ( key, params ) => {
    return makeTranslation(key, params || {}, getTranslations());
}


export default Localize;
